













































































































































































import {Component, Inject} from "vue-property-decorator";
import Api from "./Api";
import {HmsregIntegrationCompany, HmsregLocationStatus} from "../../modules/models";
import CompanyUserRequired from "../CompanyRequired";
import rd from "../../modules/vRoutedefs";

@Component
export default class HmsregSettingspage extends CompanyUserRequired {
    @Inject()
    api!: Api;

    hmsregIntegration: HmsregIntegrationCompany | null = null;
    locStatuses: HmsregLocationStatus[] = [];
    activeIntegrationLocCount = 0;

    username: string | null = null;
    password: string | null = null;

    async loadHmsregIntegration() {
        this.hmsregIntegration = await this.api.fetchHmsregIntegrationCompany(this.company.orgNum);
        if(this.hmsregIntegration != null) {
            this.activeIntegrationLocCount = await this.api.fetchHmsregIntegrationLocCount(this.company.orgNum);
            this.locStatuses = await this.api.fetchHmsregLocationStatuses(this.company.orgNum);
        }
    }

    get sumQueuedCount() {
      return this.locStatuses.map(s => s.queuedCount).reduce((prev, curr) => prev + curr, 0);
    }

    validateNonempty(inp?: string): boolean | string {
      return inp && inp.length > 0 || "Blank verdi ikke tillatt";
    }

    validateNoEmail(inp?: string): true | string {
      if(!inp) {
        return true; // Empty input is valid here (will trigger validateNonempty instead)
      } else {
        return inp.indexOf("@") < 0 || "@ verdi ikke tillatt. Brukernavn er ikke en epost adresse."
      }
    }

    get hmsregUsername() {
      return this.hmsregIntegration?.hmsregUsername || null;
    }
    get hmsreg365Username() {
      return this.hmsregIntegration?.hmsreg365Username || null;
    }

    get locationOverviewPageTo() {
        return {name: rd.locations.name};
    }

    locationTo(id: number) {
      return {name: rd.locations.location.name, params: {locationId: id}};
    }

    activating = false;
    async activate() {
        this.activating = true;
        // XXX Special case of saving instead of activating below can probably be removed when old integration is removed.
        if(this.hmsregIntegration != null) { // Save changes instead of creating new (which would fail)
          this.hmsregIntegration.hmsreg365Username = this.username;
          this.hmsregIntegration.hmsreg365Password = this.password;
          await this.save();
        } else {
          const setting = new HmsregIntegrationCompany(this.company.orgNum, null, null, this.username, this.password);
          try {
            await this.api.hmsregIntegrationSettingsActivate(setting);
            await this.loadHmsregIntegration();
          } catch (err) {
            this.emitError(err);
          } finally {
            this.activating = false;
          }
        }
    }

    showAuthEdit = false;

    async save() {
        this.activating = true;
        try {
            const setting = this.hmsregIntegration;
            if(setting != null) {
              await this.api.hmsregIntegrationSettingsSave(setting);
              await this.loadHmsregIntegration();
              this.snack(`Pålogging endret.`);
            } else {
              this.snack("FEIL: Ingen innstilling funnet");
            }
        } catch(err) {
            this.emitError(err);
        } finally {
          this.showAuthEdit = false;
          this.activating = false;
        }
    }

    showSnack = false;
    snackTxt = "";
    snack(txt: string) {
        this.snackTxt = txt;
        this.showSnack = true;
    }

    showDeactivateConfirm = false;
    async deactivate() {
        this.activating = true;
        try {
            await this.api.hmsregIntegrationSettingsDeactivate(this.company.orgNum);
            await this.loadHmsregIntegration();
            this.snack("HMSREG integrasjon deaktivert");
        } catch (err) {
            this.emitError(err);
        } finally {
            this.activating = false;
            this.showDeactivateConfirm = false;
        }

    }

    loaded = false;
    created() {
        // TODO Rewrite to use vuex completly, avoid use of promise method
        this.baseApi.loadCompanyPromise().then(() => {
            this.loadHmsregIntegration().then(() => {
                this.loaded = true;
            });
        });
    }

}
